import { Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useCSSVariable } from "uniwind";
import { useBack } from "@/shared/hooks/use-back";
import { cn } from "@/shared/lib/utils";

interface BackButtonProps {
  fallbackHref?: string;
  accessibilityLabel?: string;
  className?: string;
  onPress?: () => void;
}

export function BackButton({
  fallbackHref = "/",
  accessibilityLabel = "Go back",
  className,
  onPress,
}: BackButtonProps) {
  const handleBack = useBack(fallbackHref);
  const foreground = useCSSVariable("--color-foreground") as string;

  return (
    <Pressable
      onPress={onPress ?? handleBack}
      className={cn("h-10 w-10 items-center justify-center", className)}
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
    >
      <Ionicons name="chevron-back" size={24} color={foreground} />
    </Pressable>
  );
}
